import { FETCH_PAGINATED_MATERIALS, FETCH_ALL_MATERIALS, MATERIAL_QUERY } from './../../mutation-types';

export default {
  [FETCH_PAGINATED_MATERIALS](state, { materials, pagination }) {
    state.items = materials;
    state.pagination = pagination;
  },

  [FETCH_ALL_MATERIALS](state, material) {
    state.all = material;
  },

  [MATERIAL_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/material/mutations.js